<section>
    <main>
        <div>
            <img [ngSrc]="'assets/images/logoIbero.png'" alt="Ibero logo" height="44" width="146" priority>
        </div>
        <div>
            <p>
                Selecciona el perfil que se ajusta a tu vínculo con <span>IBERO</span>.
            </p>
        </div>
        <button id="loginButton" (click)="login()">
            <span>Estudiante o Docente</span>
            <img [ngSrc]="'assets/images/estudiante.png'" alt="Estudiante" height="96" width="64">
        </button>
        <button id="login-button-okta" (click)="loginWithOkta()">
            <span>Personal Administrativo</span>
            <img [ngSrc]="'assets/images/administrativo.png'" alt="Administrativo" height="96" width="64">
        </button>
    </main>
</section>